import { styled } from 'styled-components';
// Without a step the wrapper keeps the 4px it started with, so an existing usage stays
// where it is and a wider gap is asked for explicitly.
const toGap = ({ sm, md, lg, xl }) => {
    if (xl) {
        return '24px';
    }
    if (lg) {
        return '16px';
    }
    if (md) {
        return '12px';
    }
    if (sm) {
        return '8px';
    }
    return '4px';
};
export const GapWrapper = styled.div `
  display: flex;
  gap: ${toGap};
  align-items: ${({ $align }) => $align ?? 'flex-start'};
  flex-direction: ${({ $direction }) => $direction ?? 'row'};
  flex-wrap: ${({ wrap }) => (wrap ? 'wrap' : 'nowrap')};
`;
